<template>
  <ComboboxRoot
    :open="open"
    @click.stop
    ref="comboboxRef"
    class="relative z-[100]"
  >
    <ComboboxAnchor>
      <Trigger :label="$t('components.combobox.open')" @click="open = !open">
        <template #trigger>
          <slot name="trigger" />
        </template>
      </Trigger>
    </ComboboxAnchor>
    <ComboboxContent
      class="absolute ltr:-right-2 rtl:-left-2 z-10 w-[240px] max-h-[400px] mt-2 bg-primary overflow-hidden rounded-md border border-secondary shadow-lg"
    >
      <ComboboxViewport class="py-1.5">
        <Header />
        <ComboboxSeparator class="border-secondary border-t my-1.5" />
        <ComboboxEmpty
          class="text-style-sm font-medium text-secondary px-3 py-2"
        />
        <ComboboxGroup v-for="(group, index) in groups" :key="index">
          <ComboboxSeparator
            v-if="index !== 0"
            class="border-secondary border-t mt-1.5"
          />
          <RadioButton
            v-for="(option, index) in group.options"
            @select.prevent
            @select="(event) => handleSort(event)"
            :checked="isChecked(option.id)"
            :value="option.id"
            :key="index"
            :label="option.label"
            class="group cursor-pointer text-style-sm mx-1.5 font-medium text-secondary rounded-sm px-2.5 flex items-center h-[40px] relative select-none data-[disabled]:text-disabled data-[disabled]:pointer-events-none data-[highlighted]:outline-none data-[highlighted]:bg-primary_hover data-[highlighted]:text-secondary_hover focus:text-secondary focus:bg-transparent"
          />
        </ComboboxGroup>
      </ComboboxViewport>
      <OrderButtons v-if="sortingValues" :type="type" />
    </ComboboxContent>
  </ComboboxRoot>
</template>

<script setup>
import { ref } from "vue";
import {
  ComboboxAnchor,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxGroup,
  ComboboxRoot,
  ComboboxSeparator,
  ComboboxViewport,
} from "radix-vue";
import { Trigger, Header, OrderButtons } from "@/SharedComponents/Combobox";
import { RadioButton } from "@/SharedComponents/Combobox/Inputs";
import { useClickOutside } from "@/Composables/useClickOutside";

import { storeToRefs } from "pinia";
import { useSorting } from "@/Composables/useSorting.js";

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  groups: {
    type: Array,
    required: true,
  },
});

const sortingStore = useSorting(props.type);
const { sortingValues } = storeToRefs(sortingStore);
const { handleSortingChange } = sortingStore;

const comboboxRef = ref(null);
const open = ref(false);

useClickOutside(comboboxRef, () => {
  open.value = false;
});

const isChecked = (value) => {
  return sortingValues.value.sort_by === value;
};

const handleSort = (event) => {
  const option = event.detail.value;

  if (sortingValues.value.sort_by === option) {
    return;
  }

  handleSortingChange({
    id: option,
    desc:
      option === "scheduled_for" ||
      option === "completed_at" ||
      option === "created_at",
  });
};
</script>
